export default __webpack_public_path__ + "static/HeldaneDisplayWeb-Bold-8a87f08cc027284bfb24c3648329948e.woff";